import FeatureGates from '@atlaskit/feature-gate-js-client';

export type ChatRefreshV2DynamicConfig = {
	isMiniModalStaticPositioningEnabled: boolean;
};

export const initialState: ChatRefreshV2DynamicConfig = {
	isMiniModalStaticPositioningEnabled: false,
};

const rovoChatRefreshV2ConfigDefaultValues = JSON.stringify(initialState);

export const getChatRefreshV2DynamicConfig = (): ChatRefreshV2DynamicConfig => {
	const isRolloutInJiraEnabled =
		FeatureGates.getExperimentValue<string>('jira_ai_rovo_button', 'treatment', 'A') === 'B';

	const rovoChatRefreshV2ConfigResponse =
		isRolloutInJiraEnabled ||
		FeatureGates.getExperimentValue(
			'rovo_chat_refresh_v1_experiment',
			'isRenderRefreshEnabled',
			false,
		)
			? FeatureGates.getExperimentValue(
					'rovo_chat_refresh_v2_config',
					'value',
					rovoChatRefreshV2ConfigDefaultValues,
				)
			: rovoChatRefreshV2ConfigDefaultValues;

	let rovoChatRefreshV2Config = initialState;

	try {
		rovoChatRefreshV2Config = JSON.parse(
			rovoChatRefreshV2ConfigResponse,
		) as ChatRefreshV2DynamicConfig;
	} catch (error) {
		// fail silently
	}

	return rovoChatRefreshV2Config;
};
